<template>
  <div>
    <button class="btn btn-success" @click="addCircuit" v-show="loops.length !== usedLoops.length">
      新增線路
    </button>
    <div class="card mt-3" v-for="(circuit, index) in circuits" :key="index">
      <div class="card-header nav justify-content-between">
        <div class="h5" v-show="!circuit.isShowInput" @click="showInput(index)">
          {{ circuit.alias ?? `線路 ${index + 1}` }}
        </div>
        <div class="h5" v-show="circuit.isShowInput">
          <div class="form-group">
            <input class="form-control" type="text" id="alias" v-model.lazy="circuit.alias" placeholder="輸入線路名稱">
          </div>
        </div>
        <div>
          <button class="btn btn-primary btn-sm" data-toggle="collapse" :data-target="`#addLoopIntoChannel` + index"
            v-show="loops.length !== usedLoops.length">
            選擇要加入的迴路
          </button>
          <button class="btn btn-danger btn-sm" @click="removeCircuit(index)" data-toggle="collapse"
            :data-target="`#addLoopIntoChannel` + index">移除線路</button>
        </div>
        <div :id="`addLoopIntoChannel` + index" class="collapse">
          <div class="card">
            <div class="card-body row">
              <div v-for="(loop, loopIndex) in loops" :key="loopIndex" class="p-0 mx-2 my-1 col">
                <button @click="selectedLoop(loop)" class="btn btn-sm" :disabled="usedLoops.includes(loop)"
                  :class="{ active: selectedLoops.includes(loop), 'btn-outline-secondary': usedLoops.includes(loop), 'btn-outline-info': !usedLoops.includes(loop) }">
                  {{ loop }}
                </button>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
              <button class="btn btn-sm btn-danger mx-1" data-toggle="collapse"
                :data-target="`#addLoopIntoChannel` + index">取消加入</button>
              <button class="btn btn-success btn-sm addLoopBtn" @click="addToCircuit(index)" data-toggle="collapse"
                :data-target="`#addLoopIntoChannel` + index">
                加入迴路
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div v-for="(loop, loopIndex) in circuit.channels" :key="loopIndex" class="col-2 p-1">
          <a href="#" class="w-100 badge badge-primary" @click="removeChannel(loop)">
            {{ loop }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loops: [
        'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8',
      ],
      circuits: [],
      selectedLoops: [],
      usedLoops: [],
      base_url,
      circuit_alias: '',
    }
  },
  mounted() {
    if (this.$props.meterData && this.$props.meterData.bx_circuits) {
      this.circuits = [];
      this.usedLoops = [];
      this.$props.meterData.bx_circuits.forEach((circuit) => {
        this.circuits.push({
          alias: circuit.alias,
          id: circuit.id,
          channels: circuit.channels.split(','),
          isShowInput: false,
        });
        circuit.channels.split(',').map((circuit) => (this.usedLoops.push(circuit)))
      })
    }
  },
  watch: {
    circuits() {
      this.$emit('update-circuits', this.circuits);
      this.circuits.map((circuit) => (circuit.isShowInput = false));
    },
    meterData() {
      this.circuits = [];
      this.usedLoops = [];
      this.$props.meterData.bx_circuits.forEach((circuit) => {
        this.circuits.push({
          alias: circuit.alias,
          id: circuit.id,
          channels: circuit.channels.split(','),
          isShowInput: false,
        });
        circuit.channels.split(',').map((circuit) => (this.usedLoops.push(circuit)))
      })
    }
  },
  methods: {
    showInput(index) {
      this.circuits.map((circuit) => (
        circuit.isShowInput = false
      ));
      this.circuits[index].isShowInput = true;
    },
    addCircuit() {
      if (this.circuits.length < 24) {
        this.circuits.push({ channels: [], isShowInput: false });
      } else {
        alert("已達到迴路上限，無法新增頻道。");
      }
    },
    selectedLoop(loop) {
      if (this.selectedLoops.includes(loop)) {
        const selectedLoopIndex = this.selectedLoops.indexOf(loop);
        if (selectedLoopIndex !== -1) {
          this.selectedLoops.splice(selectedLoopIndex, 1);
        }
      } else {
        this.selectedLoops.push(loop);
      }
    },
    removeCircuit(index) {
      this.usedLoops = this.usedLoops.filter((item) => {
        return !this.circuits[index].channels.includes(item);
      });
      this.circuits.splice(index, 1);
    },
    addToCircuit(channelIndex) {
      const circuits = this.circuits[channelIndex];
      if (this.selectedLoops.length > 0) {
        this.selectedLoops.forEach(loop => {
          if (circuits.channels.length < 24) {
            circuits.channels.push(loop);
            this.usedLoops.push(loop);
            this.selectedLoops = [];
          } else {
            alert("該頻道已達到迴路上限，無法再添加迴路。");
          }
        });
      }
    },
    removeChannel(loop) {
      this.circuits = this.circuits.map(circuit => {
        // 使用 filter 方法移除指定的值
        circuit.channels = circuit.channels.filter(channel => channel !== loop);
        return circuit;
      });
      this.usedLoops = this.usedLoops.filter(item => item !== loop);
    }
  },
  props: ['meterData'],
}
</script>
